import styled, { css } from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

type ContainerProps = {
  secondary?: boolean
}

const shouldForwardProp = (prop: string) =>
  ![...DIV_SHOULD_FORWARD_PROP, 'secondary'].includes(prop)

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    background: none;
  `

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  background-color: ${themeGet('colors.background.screenAlt')};
  width: 100%;

  ${containerSecondaryCss}
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${padding}
`
